import "./InputIcon.scss";

export const InputIcon = ({ children }: { children: JSX.Element }) => {
  return <div className="input-icon">{children}</div>;
};
